import { Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

// project imports
import MinimalLayout from 'layout/MinimalLayout';
import GuestGuard from 'utils/route-guard/GuestGuard';
// import AuthGuard from 'utils/route-guard/AuthGuard';

// ==============================|| PUBLIC ROUTING ||============================== //

const PublicRoutes: RouteObject = {
  path: '/',
  element: <MinimalLayout />,
  errorElement: <ErrorBoundary />,
  children: [
    {
      path: '/',
      element: <Navigate to="/login" replace />
    },
    {
      // NEX-1335 — página del diseño anterior, sin ningún link real que lleve
      // ahí. Se redirige en vez de mostrarla; el componente queda sin borrar.
      path: '/coming-soon',
      element: <Navigate to="/" replace />
    },

    {
      // NEX-1335 — registro de transportista con la plantilla vieja, solo
      // alcanzable antes por el "coming soon" ya redirigido arriba.
      path: '/transportista-register',
      element: <Navigate to="/" replace />
    }
  ]
};

export default PublicRoutes;
